import { AxiosResponse } from "axios";
import { HelpCenterVisitorToken } from "@/domain/entities/HelpCenterVisitorToken";

export class HelpCenterMapper {
  public convertVisitorTokenFromApi(
    result: AxiosResponse<any>
  ): HelpCenterVisitorToken {
    const { data } = result;
    return new HelpCenterVisitorToken({
      token: data.data?.token || "",
      siteUrl: data.data?.site_url || "",
      expiresAt: data.data?.expires_at || ""
    });
  }
}
